import Vue from "vue";
const vm = Vue.prototype;

export const state = () => ({
  admissionSessions: [],
  admissionSession: {},
});

export const mutations = {
  SET_ADMISSION_SESSIONS(state, payload) {
    state.admissionSessions = vm.$toArray(payload);
  },

  SET_ADMISSION_SESSION_BY_ID(state, payload) {
    state.admissionSession = payload || {};
  },
};

export const actions = {
  async INIT_ADMISSION_SESSIONS({ commit }, options) {
    const { itemsPerPage, search = "", sortBy = [], sortDesc = [] } = options;

    const page = Number(options.page - 1) || 0;
    const sortField = sortBy.length ? sortBy[0] : "";
    const sortOrder = sortDesc.length && sortDesc[0] ? "desc" : "asc";

    const senc = search ? encodeURI(search) : null;

    const query = `?page=${page}&size=${itemsPerPage}&name=${senc}&sortField=${sortField}&sortOrder=${sortOrder}`;
    let totalItemsCount = 0;

    const data = await vm.$axios.$get(`admin/admission-session${query}`);
    if (data) {
      commit("SET_ADMISSION_SESSIONS", data.content);

      totalItemsCount = data.totalElements;
    }

    return totalItemsCount;
  },

  async ADMISSION_SESSION_BY_ID({ commit }, { id }) {
    let status = false;

    try {
      const data = await vm.$axios.$get(`admin/admission-session/${id}`);
      if (Array.isArray(data)) {
        commit("SET_ADMISSION_SESSION_BY_ID", data);

        status = true;
      }
    } catch (error) {
      //
    }

    return status;
  },

  async ADD_ADMISSION_SESSION(ctx, admissionSession) {
    let status = false;
    const url = "admin/admission-session";
    const method = admissionSession.id ? "$post" : "$put";

    status = await vm.$axios[method](url, admissionSession);

    return status;
  },

  async ADMISSION_SESSION_STATUS(ctx, { id, active }) {
    let status = false;

    const url = `admin/admission-session/${id}/`;
    const method = !active ? "deactivation" : "activation";

    status = await vm.$axios.$post(url + method);

    return status;
  },

  async REG_ADMISSION_SESSION_STATUS(ctx, { id, regActive }) {
    let status = false;

    const url = `admin/admission-session/${id}/`;
    const method = !regActive ? "deregactivation" : "regactivation";

    status = await vm.$axios.$post(url + method);

    return status;
  },
};

export const getters = {
  GET_ADMISSION_SESSIONS: (state) => state.admissionSessions,
  GET_ADMISSION_SESSION_BY_ID: (state) => state.admissionSession,
};
